const headingStyles = {
    'slt-heading-4xl': {
        fontFamily: 'georgia',
        fontWeight: 700,
        fontSize: '2.75rem',
        lineHeight: '3.5rem',
        letterSpacing: '0.09375rem',
    },
    'slt-heading-2xl': {
        fontFamily: 'brandon-grotesque',
        fontWeight: 700,
        fontSize: '2rem',
        lineHeight: '2.75rem',
        letterSpacing: '0.015625rem',
    },
    'slt-heading-xl': {
        fontFamily: 'brandon-grotesque',
        fontWeight: 700,
        fontSize: '1.5rem',
        lineHeight: '2.25rem',
        letterSpacing: '0.015625rem',
    },
    'slt-heading-lg': {
        fontFamily: 'brandon-grotesque',
        fontWeight: 700,
        fontSize: '1.375rem',
        lineHeight: '1.625rem',
        letterSpacing: '0.01563rem',
    },
};

const bodyStyles = {
    'slt-body-text-xl': {
        fontFamily: 'brandon-grotesque',
        fontWeight: 400,
        fontSize: '1.25rem',
        lineHeight: '1.75rem',
        letterSpacing: '0.015625rem',
    },
    'slt-body-text-lg': {
        fontFamily: 'brandon-grotesque',
        fontWeight: 400,
        fontSize: '1.125rem',
        lineHeight: '1.625rem',
        letterSpacing: '0.015625rem',
    },
    'slt-body-text': {
        fontFamily: 'brandon-grotesque',
        fontWeight: 400,
        fontSize: '1rem',
        lineHeight: '1.375rem',
        letterSpacing: '0.015625rem',
    },
    'slt-body-text-2': {
        fontFamily: 'georgia',
        fontWeight: 400,
        fontSize: '1rem',
        lineHeight: '1.375rem',
        letterSpacing: '0.015625rem',
    },
    'slt-body-text-button': {
        fontFamily: 'brandon-grotesque',
        fontWeight: 700,
        fontSize: '1rem',
        lineHeight: '1rem',
        letterSpacing: '0.0625rem',
        textTransform: 'Uppercase',
    },
};

const microStyles = {
    'slt-micro-legend': {
        fontFamily: 'brandon-grotesque',
        fontWeight: 400,
        fontSize: '0.875rem',
        lineHeight: '1.25rem',
        letterSpacing: '0.015625rem',
    },
};

const siteGenesisStyles = {
    'slt-former-heading-micro': {
        fontFamily: 'Lato,sans-serif',
        fontWeight: 700,
        fontSize: '0.875rem',
        lineHeight: '1.375rem',
        letterSpacing: '0.015625rem',
    },
    'slt-former-heading-menu': {
        color: 'slt-black.600',
        fontFamily: 'Lato,sans-serif',
        fontWeight: 700,
        fontSize: '1rem',
        lineHeight: '1.625rem',
        letterSpacing: '0.08px',
    },
    'slt-former-body-text': {
        color: 'slt-black.900',
        fontFamily: 'Lato,sans-serif',
        fontWeight: 400,
        fontSize: '1rem',
        lineHeight: '1.2rem',
        letterSpacing: '0.05rem',
    },
    'slt-former-body': {
        color: 'slt-black.600',
        fontFamily: 'Lato,sans-serif',
        fontWeight: 400,
        fontSize: '0.875rem',
        lineHeight: '14px',
        letterSpacing: '0.14px',
    },
};

// new PDP typography starts

const xsFontStyles = {
    fontFamily: 'TT Norms Pro',
    fontSize: '0.75rem',
    lineHeight: '1.125rem',
    letterSpacing: '0.03125rem',
};

const smallFontStyles = {
    fontFamily: 'TT Norms Pro',
    fontSize: '0.875rem',
    lineHeight: '1.375rem',
    letterSpacing: '0.03125rem',
};

const baseFontStyles = {
    fontFamily: 'TT Norms Pro',
    fontSize: '1rem',
    lineHeight: '1.5rem',
    letterSpacing: '0.03125rem',
};

const mediumFontStyles = {
    fontFamily: 'TT Norms Pro',
    fontSize: '1.125rem',
    lineHeight: '1.75rem',
    letterSpacing: '0.0375rem',
};

const largeFontStyles = {
    fontFamily: 'TT Norms Pro',
    fontSize: '1.25rem',
    lineHeight: '1.875rem',
    letterSpacing: '0.0375rem',
};

const large2FontStyles = {
    fontFamily: 'TT Norms Pro',
    fontSize: '1.25rem',
    lineHeight: '1.875rem',
    letterSpacing: '0.6px',
};

const typography = {
    'body-xs': {
        ...xsFontStyles,
    },
    'body-small': {
        ...smallFontStyles,
    },
    'body-base': {
        ...baseFontStyles,
    },
    'body-base-pepper-1000': {
        ...baseFontStyles,
        color: 'slt-pepper.1000',
    },
    'body-medium': {
        ...mediumFontStyles,
    },
    'body-large': {
        ...largeFontStyles,
    },
    'body-large-2': {
        ...large2FontStyles,
    },
    'protection-coverage-subtitle': {
        ...baseFontStyles,
        color: 'slt-pepper.1000',
        fontWeight: 500,
        letterSpacing: '0.5px',
    },
    'protection-coverage-text': {
        ...smallFontStyles,
        color: 'slt-pepper.1000',
        fontWeight: 400,
    },
    'cross-base': {
        ...baseFontStyles,
        textDecoration: 'line-through',
    },
    'cross-xs': {
        ...xsFontStyles,
        textDecoration: 'line-through',
    },
    'cross-small': {
        ...smallFontStyles,
        textDecoration: 'line-through',
    },
    'cross-medium': {
        ...mediumFontStyles,
        textDecoration: 'line-through',
    },
    'link-xs': {
        ...xsFontStyles,
        textDecoration: 'underline',
    },
    'link-small': {
        ...smallFontStyles,
        textDecoration: 'underline',
        textUnderlineOffset: '4px',
    },
    'link-base': {
        ...baseFontStyles,
        textDecoration: 'underline',
        textUnderlineOffset: '4px',
    },
    'link-medium': {
        ...mediumFontStyles,
        textDecoration: 'underline',
        textUnderlineOffset: '4px',
    },
    'all-caps-xs': {
        ...xsFontStyles,
        textTransform: 'uppercase',
    },
    'all-caps-small': {
        ...smallFontStyles,
        textTransform: 'uppercase',
    },
    'all-caps-base': {
        ...baseFontStyles,
        textTransform: 'uppercase',
    },
    'all-caps-medium': {
        ...mediumFontStyles,
        textTransform: 'uppercase',
    },
    'link-header': {
        textDecoration: 'underline',
        textUnderlineOffset: '10px',
        textDecorationColor: 'slt-pepper.300',
    },
};
// new PDP typography ends

export const textStyles = {
    ...headingStyles,
    ...bodyStyles,
    ...microStyles,
    ...siteGenesisStyles,
    ...typography,
};
